import { render, staticRenderFns } from "./WfBridgeDownloadModal.vue?vue&type=template&id=4c8cc550&scoped=true"
import script from "./WfBridgeDownloadModal.vue?vue&type=script&lang=js"
export * from "./WfBridgeDownloadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cc550",
  null
  
)

export default component.exports